import React, { FC } from 'react';
import { CollectionType } from '../../data-layer/collections/service';
import { DataTestId } from '../../ui/layout/DataTestIdWrapper';
import { Tab, Tabs } from '../../ui/navigation/Tabs';
import { Typography } from '../../ui/typography/Typography';
import { useTranslation } from '../../utils/useTranslation';

export interface UserCollectionsTabsProps {
    collectionType: CollectionType;
    onChange: (value: CollectionType) => void;
}

export const UserCollectionsTabs: FC<UserCollectionsTabsProps> = ({ collectionType, onChange }) => {
    const t = useTranslation();

    return (
        <Tabs mb={2} mx={2} value={collectionType} onChange={onChange}>
            <Tab width="50%" value="created" textDecoration="none" dataTestId={DataTestId.CREATED}>
                <Typography color="inherit" variant="body" weight="medium" textAlign="center">
                    {t('Созданные')}
                </Typography>
            </Tab>
            <Tab width="50%" value="saved" textDecoration="none" dataTestId={DataTestId.SAVED}>
                <Typography color="inherit" variant="body" weight="medium" textAlign="center">
                    {t('Сохранённые')}
                </Typography>
            </Tab>
        </Tabs>
    );
};
